import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getAdvertiserHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/"
)({
    component: AdvertiserEntriesRequestsPage,
    staticData: {
        permissions: [PermissionEnum.AdvertiserEntryView],
        showInSideMenu: false,
        label: "pages.advertiser.request.entry.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.advertiser.request.entry.title"),
        };
    },
});

function AdvertiserEntriesRequestsPage(): JSX.Element {
    return (
        <TenantPage headerNavigationItems={getAdvertiserHeaderItems}>
            <></>
        </TenantPage>
    );
}
